const namespace = "velaro";

type StorageKey =
  | "viewedPages"
  | "pageHits"
  | "engagements"
  | "hitCount"
  | "inviteFired"
  | "inviteViews"
  | "events"
  | "languageDisplayName"
  | "visitorDisplayName"
  | "visitorEmail"
  | "customData"
  | "visitorPhone";

class LocalStorageStore {
  get(key: StorageKey) {
    const json = localStorage.getItem(`${namespace}_${key}`);

    if (json === null || json === undefined) {
      return undefined;
    }

    try {
      return JSON.parse(json);
    } catch (err) {
      return undefined;
    }
  }

  set(key: StorageKey, value: any, options?: {}) {
    if (value === null || value === undefined) {
      this.clear(key, options);
      return;
    }

    localStorage.setItem(`${namespace}_${key}`, JSON.stringify(value));
  }

  clear(key: StorageKey, options?: {}) {
    localStorage.removeItem(`${namespace}_${key}`);
  }
}

export default LocalStorageStore;
